import { SpecialItemTable } from './SpecialItemTable'
export default SpecialItemTable
